module.exports = __webpack_public_path__ + "static/img/carousel_2_klrq02_ar_4_3_w_1534.8c12d89.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/carousel/carousel_2_klrq02_ar_4_3_w_1534.jpg
// module id = 5jOQ
// module chunks = 0